import script from "./TabComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabComponent.vue?vue&type=script&setup=true&lang=js"

import "./TabComponent.vue?vue&type=style&index=0&id=4e551f8f&lang=scss&scoped=true"
script.__scopeId = "data-v-4e551f8f"

export default script